/**
 * 大海龟旅店数据注册：地图、对白、时间线进入基础注册表；店里的群众演员登记进 ACTOR_DEFS
 * （显示名 + 开发期配色；正式资源按 `actor-<id>` / `portrait-<id>` key 到货即替换）；`?showcase=turtle-inn`（先装 turtle-inn 资源组）。
 * 导入即注册，幂等；场景与测试都可以导入。
 */
import type Phaser from 'phaser';
import { ctxOf } from '@/core/context';
import { registerMap } from '@/maps';
import { registerDialogues } from '@/dialogue';
import { registerTimelines } from '@/cinematics';
import { ACTOR_DEFS } from '@/characters';
import { SHOWCASES } from '@/content/ShowcaseScene';
import { SceneKeys } from '@/core/scenes/keys';
import type { SceneEntryData } from '@/core/types';
import { innActorDefs } from './innCast';
import { INN_DIALOGUES } from './innDialogues';
import { INN_MAP } from './innMap';
import { INN_TIMELINES } from './innTimelines';

let registered = false;
export function registerTurtleInn(): void {
  if (registered) return;
  registered = true;
  registerMap(INN_MAP);
  registerDialogues(INN_DIALOGUES);
  registerTimelines(INN_TIMELINES);
  for (const [id, def] of Object.entries(innActorDefs())) if (!ACTOR_DEFS[id]) ACTOR_DEFS[id] = def;
  SHOWCASES['turtle-inn'] = (host: Phaser.Scene) => {
    const mgr = host.scene;
    const launch = () => {
      mgr.launch(SceneKeys.TURTLE_INN, { spawn: 'inn-entrance' } satisfies SceneEntryData);
      if (mgr.get(SceneKeys.UI)) mgr.bringToTop(SceneKeys.UI);
    };
    // PreloadScene 只装 shared 组：正式的旅店图集（actor-luo-dahu、actor-patron-*…）在 turtle-inn 组，先经 Router 装好再进店。
    let ctx: ReturnType<typeof ctxOf> | undefined;
    try { ctx = ctxOf(host); } catch { ctx = undefined; }
    const load = ctx?.router?.loadGroup('turtle-inn');
    if (load) void load.catch((e: unknown) => console.warn('[turtle-inn] chapter art failed to load — dev placeholders in use', e)).then(launch);
    else launch();
  };
}
registerTurtleInn();
